'use strict';

import Api from 'services/api';


var TeamActionCreators = {

    getTeams() {
        Api.TEAMS.getTeams();
    },
    getTeamsByActionType(displayTypeId, paging) {
        Api.TEAMS.getTeamsByDisplayType(displayTypeId, paging);
    },
    getMoreTeams(nextPageLink) {
        Api.TEAMS.getMoreTeams(nextPageLink);
    },
    getMoreTeamsByActionType(nextPageLink, displayTypeId) {
        Api.TEAMS.getMoreTeams(nextPageLink, displayTypeId);
    },
    getSingleTeam(id) {
    	Api.TEAMS.getTeam(id);
    },
    getSingleTeamMembers(data) {
        Api.TEAMS.getTeamMembers(data);
    },
    getMoreTeamMembers(data) {
        Api.TEAMS.getMoreTeamMembers(data);
    },
    getSingleTeamManagers(data) {
        Api.TEAMS.getTeamManagers(data);
    },
    getMoreTeamManagers(data) {
        Api.TEAMS.getMoreTeamManagers(data);
    },
    getMultipleTeams(data) {
        Api.TEAMS.getMultipleTeams(data);  
    },
    getMultipleTeamManagers(data) {
        Api.TEAMS.getMultipleTeamManagers(data);
    },
    getMultipleTeamMembers(data) {
        Api.TEAMS.getMultipleTeamMembers(data);
    },
    getActivationStatus(data) {
        Api.TEAMS.getActivationStatus(data);
    },
    addTeam(roleName) {
        Api.TEAMS.addTeam(roleName).then(function (response) {
            TeamActionCreators.getTeams();
        });
    },
    editTeam(team) {
        Api.TEAMS.editTeam(team).then(function (response) {
            // TeamActionCreators.getSingleTeamMembers(team.Id);            
            TeamActionCreators.getTeams();            
        });
    },
    deleteTeam(teamId) {
        Api.TEAMS.deleteTeam(teamId);
    },
    addPersonToTeam(team, person, roles, rolesToRemove) {},
    getFilteredTeams(lookupString, top = 5, skip = 0) {
        Api.TEAMS.getFilteredTeams(lookupString, top, skip);
    },
    getTeamMembersCount() {
        Api.TEAMS.getTeamMembersCount();
    },
    getUsersManagers() {
        Api.TEAMS.getUsersManagers();
    },
    getUsersMembersOnLeave(date) {
        Api.TEAMS.getUsersMembersOnLeave(date);
    },
    getUnassignedTeamInfo() {
        Api.TEAMS.getUnassignedTeamInfo();
    }, 
};

export default TeamActionCreators; 
